export class configSettings {
    static environment = 'https://timeapp.rosendin.com/rosendintimeapi';
    static googleAnalyticsKey = '';
    static isDev = true;
    static botEnvironment = 'http://localhost:3001';
    static supportMailAddress = 'appsupport@rosendin.com';
    static serviceNowUrl = "https://rosendin.service-now.com/esc?id=sc_cat_item&sys_id=5fd6868693464610db9d7ec08bba10b5";
    static logoutTime = 4 * 60 * 60 * 1000; // given milliseconds for 4 hours. Value should be in milliseconds.
}